import Track from './Track'
import WebAudioTrack from '@/services/MediaService/tracks/WebAudioTrack'

// Matches HTML5 MediaElement API
export default class Sound extends Track {
  constructor (url) {
    super()

    this.obj = new WebAudioTrack({
      src: [{ url: url }]
    })

    this.bindEvents()
  }

  load () {
    return new Promise(resolve => {
      this.obj.load().then(() => {
        this.obj.volume = 1
        resolve()
      })
    })
  }

  play = () => {
    this.obj.play()
  }

  pause = () => {
    this.obj.pause()
  }

  stop = () => {
    this.obj.pause()
    this.obj.currentTime = 0
  }

  get volume () {
    return this.obj.volume
  }

  set volume (val) {
    this.obj.volume = val
  }

  get muted () {
    return this.obj.muted
  }

  set muted (val) {
    this.obj.muted = val
  }

  get currentTime () {
    return this.obj.currentTime
  }

  set currentTime (val) {
    this.obj.currentTime = val
  }

  get duration () {
    return this.obj.duration
  }

  get paused () {
    return !this.obj.playing
  }
}
